import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-logo',
    standalone: true,
    imports: [
        NgIf,
    ],
    templateUrl: './logo.component.html',
    styleUrl: './logo.component.scss',
})
export class LogoComponent {
    @Input() public alt: string = '';

    @Input() public logo: string | undefined;
}
